import React, { useEffect, useRef, useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { useField } from 'react-final-form';

function HeaderDropdownItem({ name, value, label, onSelect }) {
  return (
    <MenuItem onSelect={() => onSelect(name, value)}>
      <code style={{ display: 'block' }}>{`${name}: ${value.replace('<fill-in>', '').trim()}`}</code>
      <em style={{ display: 'block' }}>{label}</em>
    </MenuItem>
  );
}

export default function WebhookHeadersField() {
  const { input, meta } = useField('webhook_headers');
  const textarea = useRef(null);
  const [selection, setSelection] = useState(null);
  useEffect(() => {
    if (!selection) return undefined;
    const timer = setTimeout(() => {
      textarea.current.focus();
      textarea.current.setSelectionRange(selection.start, selection.end);
      setSelection(null);
    }, 0);
    return () => clearTimeout(timer);
  }, [selection]);

  function appendHeader(name, value) {
    const text = input.value || '';
    const prefix = text + (text && !text.endsWith('\n') ? '\n' : '');
    const line = `${name}: ${value}`;
    input.onChange(prefix + line);
    const placeholder = line.indexOf('<fill-in>');
    const start = prefix.length + (placeholder < 0 ? line.length : placeholder);
    setSelection({ start, end: start + (placeholder < 0 ? 0 : '<fill-in>'.length) });
  }

  return (
    <div className="form-item">
      <label htmlFor="edit-webhook-headers">Additional webhook headers:</label>
      <div style={{ marginBottom: 8 }}>
        <DropdownButton id="webhook-common-headers" title="Common Headers" bsSize="small">
          <HeaderDropdownItem name="Authorization" value="Bearer <fill-in>"
            label="Bearer token (AI Agent / Pipedream)" onSelect={appendHeader} />
          <HeaderDropdownItem name="Authorization" value="Basic <fill-in>"
            label="Basic auth (Base64 username:password)" onSelect={appendHeader} />
          <HeaderDropdownItem name="X-API-Key" value="<fill-in>" label="API key" onSelect={appendHeader} />
          <HeaderDropdownItem name="x-make-apikey" value="<fill-in>" label="Make webhook API key" onSelect={appendHeader} />
          <HeaderDropdownItem name="X-Webhook-Secret" value="<fill-in>" label="n8n Header Auth (example name)" onSelect={appendHeader} />
          <HeaderDropdownItem name="anthropic-version" value="2023-06-01" label="Anthropic Version" onSelect={appendHeader} />
        </DropdownButton>
      </div>
      <textarea {...input} ref={textarea} id="edit-webhook-headers" rows="4" className="form-textarea"
        placeholder="eg. X-My-Custom-Header: your-value" />
      <div className="description">
        One header per line, written as Name: value. Leave empty to send no additional headers.
      </div>
      {meta.error && meta.submitFailed && <span className="error description">{meta.error}</span>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/searchAlerts/CustomAlerts/WebhookHeadersField.jsx